module.exports = __webpack_public_path__ + "img/20190629103305721.68cac011.png";